import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";

import LoadingComponent from "../../common/components/LoadingComponent";


export default function SamlCallback() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        const exchangeToken = async () => {
            const code = searchParams.get("code");

            // Missing exchange code
            if (!code) {
                navigate(
                    "/login?sso_error=authentication_failed",
                    { replace: true }
                );
                return;
            }

            try {
                const response = await axios.post(
                    `${process.env.REACT_APP_API_DOMAIN}saml/token/`,
                    { code },
                    {
                        withCredentials: true,
                    }
                );

                const tokens = {
                    accessToken: response.data.access,
                    refreshToken: response.data.refresh,
                };

                localStorage.setItem(
                    "auth-tokens-production",
                    JSON.stringify(tokens)
                );

                localStorage.setItem(
                    "remember_me",
                    "false"
                );

                navigate("/", { replace: true });

            } catch (error) {
                console.error(
                    "SAML login failed",
                    error
                );

                navigate(
                    "/login?sso_error=1",
                    { replace: true }
                );
            }
        };

        exchangeToken();
    }, [navigate, searchParams]);

    return <LoadingComponent />;
}